import * as types from '../../constants/app/maintenanceConstants';

export const maintenanceListRequest = ({
  page,
  pageLength,
  callback,
  error,
}) => ({
  type: types.MAINTENANCE_LIST_REQUEST,
  page,
  pageLength,
  callback,
  error,
});

export const setMaintenanceList = (list) => ({
  type: types.SET_MAINTENANCE_LIST,
  list,
});

export const setTotalCount = (totalCount) => ({
  type: types.SET_TOTAL_COUNT,
  totalCount,
});

export const setMaintenancePagination = (page, pageLength, totalCount) => ({
  type: types.SET_MAINTENANCE_PAGINATION,
  page,
  pageLength,
  totalCount,
});

export const maintenanceTerminate = (
  isUrgent,
  title,
  content,
  startedAt,
  endedAt,
) => ({
  type: types.MAINTENANCE_TERMINATE,
  isUrgent,
  title,
  content,
  startedAt,
  endedAt,
});

export const maintenanceCreate = ({
  isUrgent,
  title,
  content,
  startedAt,
  endedAt,
  version,
  callback,
  error,
}) => ({
  type: types.MAINTENANCE_CREATE,
  isUrgent,
  title,
  content,
  startedAt,
  endedAt,
  version,
  callback,
  error,
});

export const maintenanceDetails = ({
  maintenanceNo,
  callback,
  error,
}) => ({
  type: types.MAINTENANCE_DETAILS_REQUEST,
  maintenanceNo,
  callback,
  error,
});

export const setMaintenanceDetails = (info) => ({
  type: types.SET_MAINTENANCE_DETAILS,
  info,
});

export const maintenanceRemove = (maintenanceNo) => ({
  type: types.MAINTENANCE_REMOVE,
  maintenanceNo,
});

export const maintenanceUpdate = ({
  maintenanceNo,
  title,
  content,
  startedAt,
  endedAt,
  version,
  callback,
  error,
}) => ({
  type: types.MAINTENANCE_UPDATE,
  maintenanceNo,
  title,
  content,
  startedAt,
  endedAt,
  version,
  callback,
  error,
});

export const maintenanceResponse = (resultCode) => ({
  type: types.MAINTENANCE_RESPONSE,
  resultCode,
});

export const resetMaintenanceDetails = () => ({
  type: types.RESET_MAINTENANCE_DETAILS,
});
